import sectionCardVitalTabCss from '../css-snippets/section-card-vital-tab';

const html = `
<style>${sectionCardVitalTabCss}</style>
<div data-attribute="card-container" id="card-container-unique-id" data-id="unique-id" data-background="#ffffff"
  data-top-padding="true" data-bottom-padding="true" data-color="#000000" data-text-color="#000000"
  style="background-color: #ffffff; color: #000000; --color-text: #000000; --color-background: #ffffff; --hl-background-left-card: #eff6f9; --color-tab-header: #214a88; --color-tab-header-hover: #ffffff; --bg-tab-header-hover: #214a88;">
  <div class="container-page" data-attribute="container-page" data-show-style="false" data-background="#FFFFFF"
    style="background-color: transparent;">
    <div class="container">
      <div data-show-title="false" data-attribute="title-card" class="title-card"></div>
      <div class="wrap-card" data-right-card-position="left">
        <div data-attribute="right-card" class="right-card" data-order="1" style="order: 1;">
          <div class="wrap-image">
            <img data-attribute="image-right-card"
              src="https://cdn.skyfastimg.com/images/2026/04/03/image-69cf77d61369faceb7cf41be.webp" alt="">
          </div>
        </div>
        <div data-highlight-left-card="#eff6f9" data-attribute="left-card" class="left-card" data-order="2"
          style="order: 2;">
          <div data-attribute="title-card" class="title-card">
            <h3><strong>Start glowing in as little as 7 days</strong></h3>
          </div>
          <div class="wrap-header-tabs">
            <div data-color-tab-header="#214a88" data-color-tab-header-hover="#ffffff"
              data-bg-tab-header-hover="#214a88" data-attribute="list-tab-header" class="list-tab">
              <div class="tab-header-item active" data-tab="tab-1" data-attribute="tab-header-item">Weeks 1 - 2:</div>

              <div class="tab-header-item " data-tab="tab-2" data-attribute="tab-header-item">Weeks 3-10</div>

              <div class="tab-header-item " data-tab="tab-3" data-attribute="tab-header-item">Weeks 11+</div>
            </div>
          </div>
          <div class="wrap-content-tabs">
            <div data-attribute="list-tab-content" class="list-tab-content">
              <div class="tab-content-item active" data-tab="tab-1" data-attribute="tab-content-item">
                <div data-attribute="title-tab-content" class="title-tab-content">
                  <h2><strong>Enhanced skin hydration, elasticity and health.</strong></h2>
                  <p>&nbsp;</p>
                  <p>Support and enhance your body's natural collagen production and start experiencing more vibrant,
                    healthier and supple skin in a matter of weeks.</p>
                </div>
                <div data-attribute="foot-tab-content" class="foot-tab-content">
                  <p>
                    <span style="color:#999999;">
                      Individual results may vary, but here's an idea of what you can expect. We're not magicians, but
                      with a little bit of science these results are pretty magical.
                  </p>
                  </span>
                </div>
              </div>

              <div class="tab-content-item " data-tab="tab-2" data-attribute="tab-content-item">
                <div data-attribute="title-tab-content" class="title-tab-content">
                  <h3><span style="color:#000000;"><strong>Stronger, shinier, more vibrant hair and
                        nails.</strong></span></h3>
                  <p><br><span style="color:#000000;">Transform brittle hair, nails and stiff joints into stronger,
                      shinier hair while noticing your joints are moving freely with less aches and stiffness.</span>
                  </p>
                </div>
                <div data-attribute="foot-tab-content" class="foot-tab-content">
                  <p><span style="color:#999999;">Individual results may vary, but here’s an idea of what you can
                      expect. We’re not magicians, but with a little bit of science these results are pretty
                      magical.</span></p>
                </div>
              </div>

              <div class="tab-content-item " data-tab="tab-3" data-attribute="tab-content-item">
                <div data-attribute="title-tab-content" class="title-tab-content">
                  <h3><span style="color:#000000;"><strong>360° wellness, from the inside out.</strong></span></h3>
                  <p><br><span style="color:#000000;">Restore your body’s collagen levels to optimal and experience a
                      difference in your day-to-day well-being, vitality and overall health of your skin, hair, bones
                      and joints.</span></p>
                </div>
                <div data-attribute="foot-tab-content" class="foot-tab-content">
                  <p><span style="color:#999999;">Individual results may vary, but here’s an idea of what you can
                      expect. We’re not magicians, but with a little bit of science these results are pretty
                      magical.</span></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`;
export default html;
